/* Form page to edit a DeptPost */
import React, { useEffect, useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Asset from "../../components/Asset"

import Upload from "../../assets/upload.png"
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Image from "react-bootstrap/Image"
import Alert from "react-bootstrap/Alert"
import toast from "react-hot-toast";

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"

const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

function DeptPostEdit() {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})
  const [postData, setPostData] = useState({
    title: "",
    content: "",
    departments: "",
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
    image1Preview: null, // for URL.createObjectURL()
    image2Preview: null,
    image3Preview: null,
    image4Preview: null,
    image5Preview: null,
  })
  const {
    title,
    content,
    departments,
    // eslint-disable-next-line
    image1,
    // eslint-disable-next-line
    image2,
    // eslint-disable-next-line
    image3,
    // eslint-disable-next-line
    image4,
    // eslint-disable-next-line
    image5,
  } = postData
  const imageInput1 = useRef(null)
  const imageInput2 = useRef(null)
  const imageInput3 = useRef(null)
  const imageInput4 = useRef(null)
  const imageInput5 = useRef(null)

  const history = useHistory()
  const { id } = useParams()

  useEffect(() => {
    const handleMount = async () => {
      try {
        const fetchContentType = async (url) => {
          const response = await fetch(url, { method: "HEAD" });
          return response.headers.get("Content-Type");
        };

        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/department/posts/${id}/`);
          const {
            title,
            content,
            departments,
            image1,
            image2,
            image3,
            image4,
            image5,
            is_owner,
          } = data;

          const [type1, type2, type3, type4, type5] = await Promise.all([
            image1 ? fetchContentType(image1) : null,
            image2 ? fetchContentType(image2) : null,
            image3 ? fetchContentType(image3) : null,
            image4 ? fetchContentType(image4) : null,
            image5 ? fetchContentType(image5) : null,
          ]);

          setPostData({
            title,
            content,
            departments,
            image1,
            image2,
            image3,
            image4,
            image5,
            image1Preview: image1,
            image2Preview: image2,
            image3Preview: image3,
            image4Preview: image4,
            image5Preview: image5,
            image1Type: type1,
            image2Type: type2,
            image3Type: type3,
            image4Type: type4,
            image5Type: type5,
          });
        } else {
          const { data } = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          );

          const {
            title,
            content,
            departments,
            image1,
            image2,
            image3,
            image4,
            image5,
            is_owner,
          } = data;

          const [type1, type2, type3, type4, type5] = await Promise.all([
            image1 ? fetchContentType(image1) : null,
            image2 ? fetchContentType(image2) : null,
            image3 ? fetchContentType(image3) : null,
            image4 ? fetchContentType(image4) : null,
            image5 ? fetchContentType(image5) : null,
          ]);

          setPostData({
            title,
            content,
            departments,
            image1,
            image2,
            image3,
            image4,
            image5,
            image1Preview: image1,
            image2Preview: image2,
            image3Preview: image3,
            image4Preview: image4,
            image5Preview: image5,
            image1Type: type1,
            image2Type: type2,
            image3Type: type3,
            image4Type: type4,
            image5Type: type5,
          });
        }
      } catch (err) {
        console.error(err);
      }
    };

    handleMount();
  }, [history, id]);


  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const validateFileSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true;
    }

    if (inputRef?.current) {
      inputRef.current.value = "";
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`, {
      duration: 3000,
    });
    return false;
  };

  const handleChangeImage1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateFileSize(file, imageInput1)) {
        return;
      }
      if (postData.image1Preview) {
        URL.revokeObjectURL(postData.image1Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image1: file,
        image1Preview: previewUrl,
        image1Type: file.type,
      }));
    }
  };

  const handleChangeImage2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateFileSize(file, imageInput2)) {
        return;
      }
      if (postData.image2Preview) {
        URL.revokeObjectURL(postData.image2Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image2: file,
        image2Preview: previewUrl,
        image2Type: file.type,
      }));
    }
  };
  const handleChangeImage3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateFileSize(file, imageInput3)) {
        return;
      }
      if (postData.image3Preview) {
        URL.revokeObjectURL(postData.image3Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image3: file,
        image3Preview: previewUrl,
        image3Type: file.type,
      }));
    }
  };
  const handleChangeImage4 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateFileSize(file, imageInput4)) {
        return;
      }
      if (postData.image4Preview) {
        URL.revokeObjectURL(postData.image4Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image4: file,
        image4Preview: previewUrl,
        image4Type: file.type,
      }));
    }
  };

  const handleChangeImage5 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateFileSize(file, imageInput5)) {
        return;
      }
      if (postData.image5Preview) {
        URL.revokeObjectURL(postData.image5Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image5: file,
        image5Preview: previewUrl,
        image5Type: file.type,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()

    formData.append("title", title)
    formData.append("content", content)
    formData.append("departments", departments)
    if (imageInput1.current.files[0]) {
      formData.append("image1", imageInput1.current.files[0])
    }
    if (imageInput2.current.files[0]) {
      formData.append("image2", imageInput2.current.files[0])
    }
    if (imageInput3.current.files[0]) {
      formData.append("image3", imageInput3.current.files[0])
    }
    if (imageInput4.current.files[0]) {
      formData.append("image4", imageInput4.current.files[0])
    }
    if (imageInput5.current.files[0]) {
      formData.append("image5", imageInput5.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.put(`/department/posts/${id}`, formData)
        toast.success(`Post Updated`);
        history.push(
          `/${localStorage.getItem("projectSlug")}/department/posts/${id}`
        )
      } else {
        const response = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error
        }
        toast.success(`Post Updated Successfully!`);
        history.push(
          `/${localStorage.getItem("projectSlug")}/department/posts/${id}`
        )
      }
    } catch (err) {
      console.log(err)
      const errData = err?.response?.data || err?.error?.response?.data;
      const backendError = err ||
        errData?.error ||
        errData?.detail ||
        errData?.message ||
        "Failed to update department post.";
      toast.error(backendError);
      if (err.response?.status !== 401) {
        setErrors(errData || { detail: [backendError] })
      }
    }
  }

  const textFields = (
    <div>
      <Row className="mt-3">
        <Col className="d-flex justify-content-center" xs={12} md={6} >
          <Form.Group controlId="title" className={`${styles.Width2} text-center`} >
            <Form.Label className={`${styles.BoldScene} `} >Title</Form.Label>
            <Form.Control
              className={styles.Input}
              type="text"
              name="title"
              value={title}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.title?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col className="d-flex justify-content-center mt-3 mt-md-0" xs={12} md={6} >
          <Form.Group controlId="content" className={`${styles.Width2} text-center`} >
            <Form.Label className={`${styles.BoldScene} `} >Content</Form.Label>
            <Form.Control
              className={styles.InputScene}
              type="text"
              name="content"
              as="textarea"
              rows={1}
              value={content}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.content?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
    </div>
  )

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Update
      </Button>
    </div>
  );

  return (
    <div>
      <TopBox work={`${departments} Department`}
        title="Edit Post" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h5 style={{ textTransform: 'uppercase' }}
        className={`text-center py-1 ${styles.SubTitle}`}>
        Edit Post</h5>
      <Form className={` ${styles.White} px-3`} onSubmit={handleSubmit}>
        <Row>
          <Col className="p-0 p-md-2">
            {textFields}
          </Col>
        </Row>
        <hr />
        <div>
          {/* image 1/2 */}
          <Row>
            <Col className="text-center" md={6}>
              <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >Image/File 1</p>
              <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                <Form.Group>
                  {postData.image1Preview ? (
                    postData.image1Type === "application/pdf" ? (
                      <>
                        <iframe
                          src={postData.image1Preview}
                          className={appStyles.iframe}
                          title="PDF Preview"
                        />
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload1"
                        >
                          Change the file
                        </Form.Label>
                      </>
                    ) : (
                      <>
                        <figure>
                          <Image
                            className={appStyles.iframe}
                            style={{ borderRadius: 8, border: "none" }}
                            src={postData.image1Preview}
                            rounded
                          />
                        </figure>
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload1"
                        >
                          Change the image
                        </Form.Label>
                      </>
                    )
                  ) : (
                    <Form.Label
                      htmlFor="image-upload1"
                    >
                      <Asset
                        src={Upload}
                        height={"40px"}
                        width={"40px"}
                        message="Upload Image or PDF"
                      />
                    </Form.Label>
                  )}

                  <Form.Control
                    type="file"
                    id="image-upload1"
                    accept="image/*,.pdf"
                    onChange={handleChangeImage1}
                    ref={imageInput1}
                  />
                </Form.Group>
                {errors?.image1?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </div>
              <hr className={`d-block d-md-none`} />
            </Col>
            <Col md={6} className="text-center">
              <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >Image/File 2</p>
              <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                <Form.Group>
                  {postData.image2Preview ? (
                    postData.image2Type === "application/pdf" ? (
                      <>
                        <iframe
                          src={postData.image2Preview}
                          className={appStyles.iframe}
                          title="PDF Preview"
                        />
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload2"
                        >
                          Change the file
                        </Form.Label>
                      </>
                    ) : (
                      <>
                        <figure>
                          <Image
                            className={appStyles.iframe}
                            style={{ borderRadius: 8, border: "none" }}
                            src={postData.image2Preview}
                            rounded
                          />
                        </figure>
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload2"
                        >
                          Change the image
                        </Form.Label>
                      </>
                    )
                  ) : (
                    <Form.Label
                      htmlFor="image-upload2"
                    >
                      <Asset
                        src={Upload}
                        height={"40px"}
                        width={"40px"}
                        message="Upload Image or PDF"
                      />
                    </Form.Label>
                  )}
                  <Form.Control
                    type="file"
                    id="image-upload2"
                    accept="image/*,.pdf"
                    onChange={handleChangeImage2}
                    ref={imageInput2}
                  />
                </Form.Group>
                {errors?.image2?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </div>
              <hr className={`d-block d-md-none`} />
            </Col>
          </Row>
          <hr className={` d-none d-md-block`} />
          {/* image 3/4 */}
          <Row>
            <Col md={6} className="text-center">
              <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >Image/File 3</p>
              <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                <Form.Group>
                  {postData.image3Preview ? (
                    postData.image3Type === "application/pdf" ? (
                      <>
                        <iframe
                          src={postData.image3Preview}
                          className={appStyles.iframe}
                          title="PDF Preview"
                        />
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload3"
                        >
                          Change the file
                        </Form.Label>
                      </>
                    ) : (
                      <>
                        <figure>
                          <Image
                            className={appStyles.iframe}
                            style={{ borderRadius: 8, border: "none" }}
                            src={postData.image3Preview}
                            rounded
                          />
                        </figure>
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload3"
                        >
                          Change the image
                        </Form.Label>
                      </>
                    )
                  ) : (
                    <Form.Label
                      htmlFor="image-upload3"
                    >
                      <Asset
                        src={Upload}
                        height={"40px"}
                        width={"40px"}
                        message="Upload Image or PDF"
                      />
                    </Form.Label>
                  )}

                  <Form.Control
                    type="file"
                    id="image-upload3"
                    accept="image/*,.pdf"
                    onChange={handleChangeImage3}
                    ref={imageInput3}
                  />
                </Form.Group>
                {errors?.image3?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </div>
              <hr className={` d-block d-md-none`} />
            </Col>
            <Col md={6} className="text-center">
              <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >Image/File 4</p>
              <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                <Form.Group>
                  {postData.image4Preview ? (
                    postData.image4Type === "application/pdf" ? (
                      <>
                        <iframe
                          src={postData.image4Preview}
                          className={appStyles.iframe}
                          title="PDF Preview"
                        />
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload4"
                        >
                          Change the file
                        </Form.Label>
                      </>
                    ) : (
                      <>
                        <figure>
                          <Image
                            className={appStyles.iframe}
                            style={{ borderRadius: 8, border: "none" }}
                            src={postData.image4Preview}
                            rounded
                          />
                        </figure>
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload4"
                        >
                          Change the image
                        </Form.Label>
                      </>
                    )
                  ) : (
                    <Form.Label
                      htmlFor="image-upload4"
                    >
                      <Asset
                        src={Upload}
                        height={"40px"}
                        width={"40px"}
                        message="Upload Image or PDF"
                      />
                    </Form.Label>
                  )}

                  <Form.Control
                    type="file"
                    id="image-upload4"
                    accept="image/*,.pdf"
                    onChange={handleChangeImage4}
                    ref={imageInput4}
                  />
                </Form.Group>
                {errors?.image4?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </div>
              <hr className={` d-block d-md-none`} />
            </Col>
          </Row>
          <hr className={`d-none d-md-block`} />
          {/* image 5 */}
          <Row>
            <Col md={{ span: 6, offset: 3 }} className="text-center">
              <p className={`${styles.BoldScene} 
                  mb-0 text-center mx-3`} >Image/File 5</p>
              <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
                <Form.Group>
                  {postData.image5Preview ? (
                    postData.image5Type === "application/pdf" ? (
                      <>
                        <iframe
                          src={postData.image5Preview}
                          className={appStyles.iframe}
                          title="PDF Preview"
                        />
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload5"
                        >
                          Change the file
                        </Form.Label>
                      </>
                    ) : (
                      <>
                        <figure>
                          <Image
                            className={appStyles.iframe}
                            style={{ borderRadius: 8, border: "none" }}
                            src={postData.image5Preview}
                            rounded
                          />
                        </figure>
                        <Form.Label
                          className={`${btnStyles.Button} ${btnStyles.Blue}`}
                          htmlFor="image-upload5"
                        >
                          Change the image
                        </Form.Label>
                      </>
                    )
                  ) : (
                    <Form.Label
                      htmlFor="image-upload5"
                    >
                      <Asset
                        src={Upload}
                        height={"40px"}
                        width={"40px"}
                        message="Upload Image or PDF"
                      />
                    </Form.Label>
                  )}

                  <Form.Control
                    type="file"
                    id="image-upload5"
                    accept="image/*,application/pdf"
                    onChange={handleChangeImage5}
                    ref={imageInput5}
                  />
                </Form.Group>
                {errors?.image5?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </div>
            </Col>
          </Row>
        </div>
        {/* buttons */}
        <Row className="mt-3">
          <Col>
            {buttons}
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default DeptPostEdit
